"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMetricType = void 0;
var IMetricType;
(function (IMetricType) {
    IMetricType["Cals"] = "cals";
    IMetricType["Distance"] = "distance";
    IMetricType["ElevationGain"] = "elevation-gain";
    IMetricType["Duration"] = "duration";
    IMetricType["Pace"] = "pace";
    IMetricType["AvgWatts"] = "avg-watts";
    IMetricType["AverageSpeed"] = "average-speed";
    IMetricType["Average500MSplit"] = "average-500M-split";
    IMetricType["WorkoutsCount"] = "workouts-count";
})(IMetricType || (exports.IMetricType = IMetricType = {}));
//# sourceMappingURL=metric-type.js.map